import axios from './axios'
import { getKey } from '@/assets/utils'
import qs from 'qs'

const getMemberInfo = (memberGoods) => {
  return new Promise(async (resolve) => {
    const { data } = await axios.request({
      url: '/membership/v1/memberShipDetail',
      method: 'POST',
      data: {
        memberGoods
    } })
    if (data.success) {
      resolve(data.data)
    }
  })
}

const toCashier = (discountPrice, isPreview, memberType, memberGoodsGroupCd) => {
  // 跳转自有收银台
  const gid = localStorage.getItem('gid')
  const token = getKey('userInfo', 'token') || ''
  const device = getKey('X-DEVICE_IF')
  const queryParams = qs.stringify({
    memberType,
    memberGoodsGroupCd,
    discountPrice: discountPrice,
    gid,
    token,
    isPreview: isPreview ? 'Y' : 'N',
    device,
    refurl: window.location.origin
  })
  window.location.href = process.env.VUE_APP_PAYURL + '/pay?' + queryParams
}

const WHPay = async (isPreview, memberType = 'PSC_M', memberGoodsGroupCd = 'PASS') => {
  // 查询会员信息 获取会员价格
  const memberInfo = await getMemberInfo(memberType)
  const price = memberInfo?.memberGoods?.expirePrice || memberInfo?.memberGoods?.discountPrice || 0
  toCashier(price, isPreview, memberType, memberGoodsGroupCd)
}

export { WHPay }